import "client-only"

import { AppChannel } from "@/config/channel"
import { useConfigParams } from "@/hooks"
import { useLoginRedirectUrl } from "@/hooks/use-login-redirect-url"

export function useRedirectUrl() {
  const { channel, endCallbackUrl, community, communityShare } =
    useConfigParams()

  const loginUrl = useLoginRedirectUrl()

  const redirectUrl = endCallbackUrl ?? loginUrl.toString()

  switch (channel) {
    case AppChannel.PortaleWebFullResponsiveWwwSisalIt:
      return withCommunityParams(redirectUrl, community, communityShare)
    default:
      return "https://appmobile.sisal.it/?appFunc=close"
  }
}

function withCommunityParams(
  url: string,
  community: boolean,
  communityShare?: string,
) {
  if (!community && !communityShare) return url

  try {
    const callbackUrl = url.startsWith("/")
      ? new URL(url, window.location.origin)
      : new URL(url)

    if (community) {
      callbackUrl.searchParams.set("community", "true")
    }

    if (communityShare) {
      callbackUrl.searchParams.set("communityShare", communityShare)
    }

    return callbackUrl.toString()
  } catch {
    console.error("Invalid redirect URL:", url)
    return url
  }
}
